import PressableCustom from '@src/components/general/PressableCustom/PressableCustom';
import Button from 'design-system/src/Components/Button/Button';
import Typography from 'design-system/src/Components/Typography/Typography';
import React, {FC} from 'react';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import MenuActionHeader from '../../../AppLayout/AppHeader/MenuActionHeader';
import styled from 'styled-components';
import {useAppDispatch} from '@src/Store/hooks';
import appAuthSlice from '@src/Store/Slices/AppSlice/auth.slice';
import useNavigation from '@src/Navigation/useNavigation';
import {appNavigate} from '@src/utils/navigationUtils';
import {Routes} from '@src/Constant/routes';

export interface LoginMenuProps {
  isLoggedIn?: boolean;
  isLoading: boolean;
  isMobile: boolean;
  showSignUp?: boolean; // ← ajout ici
  onSignUpClicked?: () => void | Promise<void>;
  onSignInClicked?: () => void | Promise<void>;
  onOpenProfile?: () => void | Promise<void>;
}

const Container = styled.div`
  display: inline-flex;
  gap: 24px;
  align-items: center;
  padding: 2px;

  @media (max-width: 1300px) {
    > div > div {
      padding-left: 8px;
      padding-right: 8px;
    }
  }
`;

const LoginMenu: FC<LoginMenuProps> = ({
  isMobile,
  isLoading,
  isLoggedIn,
  showSignUp = true,
  onSignInClicked,
  onSignUpClicked,
  onOpenProfile,
}) => {
  const dispatch = useAppDispatch();
  const rootNavigation = useNavigation();
  const {t} = useTranslation(['language', 'auth']);
  const defaultOnSignUpClicked = () => {
    dispatch(appAuthSlice.actions.setAuthType('register'));
    dispatch(
      appAuthSlice.actions.setAuthStep({
        page: 'first',
        step: 0,
      }),
    );
    dispatch(
      appAuthSlice.actions.openAuthenticationModal({
        open: true,
        redirect: `/app`,
      }),
    );
  };
  const defaultOnSignInClicked = async () => {
    if (!isMobile && isLoggedIn) {
      await rootNavigation.navigate('/app');
      return;
    }

    dispatch(appAuthSlice.actions.setAuthType('login'));
    dispatch(
      appAuthSlice.actions.openAuthenticationModal({
        open: true,
        redirect: `/app`,
      }),
    );
  };
  const defaultOnOpenProfile = () => appNavigate(Routes.PROFILE_HOME);

  return (
    <Container>
      {!isLoggedIn ? (
        !isMobile ? (
          <>
            {showSignUp && ( // ← condition ici
              <PressableCustom
                onPress={onSignUpClicked ?? defaultOnSignUpClicked}>
                {({hover}) => (
                  <Typography
                    color={hover ? 'orange' : 'white'}
                    variant="button3">
                    {t('Sign up', {ns: 'auth'})}
                  </Typography>
                )}
              </PressableCustom>
            )}

            <Button
              title={t('Sign in', {ns: 'auth'})}
              variant="contained"
              disabled={isLoading}
              size="small"
              onPress={onSignInClicked ?? defaultOnSignInClicked}
            />
          </>
        ) : (
          <MenuActionHeader
            iconName="profil"
            onClick={onSignInClicked ?? defaultOnSignInClicked}
          />
        )
      ) : (
        <MenuActionHeader
          iconName="profil"
          onClick={onOpenProfile ?? defaultOnOpenProfile}
        />
      )}
    </Container>
  );
};

export default LoginMenu;
